import * as cs from "../Api/cs"

export const getGenreList = async headers => {
    const res = await cs.get('list', 'genre', null, headers);
    return res?.data?.data;
}